<template>
    <div v-if="brands != null" class="branch-contact__brands-wrap">
            <h2 class="branch-contact__brands-headline" id="brandFilterLabel">{{dictionary['branchContact.BrandSelectionLabel']}}</h2>
            <div class="branch-contact__brands-container">

            <SelectButton aria-labelledby="brandFilterLabel" class="branch-contact__brands" v-model="selectedBrand"
                :options="brands"
                optionLabel="Name" optionValue="FilterAlias" :multiple="false" :disabled="loading">
                <template #option="slotProps">
                    <img v-if="slotProps.option.HasLogoUrl"
                        :src="slotProps.option.LogoUrl" loading="lazy" alt="" height="30" />
                    <p>{{slotProps.option.Name}}</p>
                </template>
            </SelectButton>
        </div>

        </div>
        <div v-if="selectedBrand" class="branch-contact__divider"></div>
        <div v-if="branch && !loading && selectedBrand && (!departments || departments.length == 0)" class="branch-contact__branch-info">
            <p class="branch-contact__branch-headline">Semler Mobiliy {{ branch.Name }}</p>
            <address>
                {{ branch.Address }}<br/>
                {{ branch.ZipCode }} {{ branch.City }}
            </address>
            <p v-if="branch.HasPhoneNumber">
                <a :href="`tel:${branch.PhoneNumber}`">{{ branch.PhoneNumber }}</a>
            </p>
            <p>
                <a href="#branchContact">{{dictionary['branchContact.BranchFallbackMessageCta']}}</a>
            </p>
        </div>
        <div v-else class="branch-contact__department">
            <div v-if="departments">
                <label for="department" class="branch-contact__department-select-headline">{{dictionary['branchContact.DepartmentSelectionLabel']}}</label>
            <Dropdown  class="branch-contact__department-select" inputId="department" v-model="selectedDepartment" :options="departments" optionLabel="typeName"
                 :placeholder="dictionary['branchContact.DepartmentSelectionLabel']"></Dropdown>

                 <div class="branch-contact__opening-hours"  v-if="selectedDepartment && selectedDepartment.hasOpeningHours">
                    <p class="branch-contact__opening-hours-headline">{{dictionary['branchContact.OpeningHoursLabelPrefix']}} {{ selectedDepartment.typeName }}</p>
                     <OpeningHours :openingHours="selectedDepartment.openingHours"></OpeningHours>
                 </div>
        </div>
        <!-- Employees -->
        <div v-if="selectedDepartment">
            <ul class="employees-list">
                <li class="employee-card-placeholder">
                    <img src="/assets/images/speechBubble.svg" width="41" height="41" alt="" role="presentation" />
                    <p>{{dictionary['branchContact.EmployeeCardPlaceholderText']}}</p>
                    <a :href="`tel:${selectedDepartment.phone}`">Tlf.: {{ selectedDepartment.phone }}</a>
                    <a :href="`mailto:${selectedDepartment.email}`">{{dictionary['branchContact.EmailCtaLabel']}}</a>
                </li>
                <li v-for="(employee, index) in selectedDepartment.employees" :key="index" class="employee-card">
                    <img v-if="employee.hasImageUrl" :src="`${employee.imageUrl}?width=250`" alt="" />
                    <p>{{ employee.name }}</p>
                    <a v-if="employee.hasPhone" :href="`tel:${employee.phone}`">{{ employee.phone }}</a>
                    <a v-if="employee.hasEmail" :href="`mailto:${employee.email}`">{{dictionary['branchContact.EmailCtaLabel']}}</a>
                </li>
            </ul>
        </div>
        </div>
        <div v-if="selectedBrand" class="branch-contact__divider"></div>
</template>
<script>

import SelectButton from 'primevue/selectbutton';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import OpeningHours from './components/openingHours.vue';
export default {
    name: "branchContact",
    components: {
        Dialog,
        Button,
        Dropdown,
        SelectButton,
        OpeningHours
    },
    props: ['branch','shops', 'brands'],
    data() {
        return {
            dictionary: [],
            selectedDepartmentId: null,
            visible: false,
            loading:false,
            selectedBrand:null,
            selectedDepartment:null,
            departments:null
        };
    },
    created() {
        const vm = this;
        vm.loading = true;

        fetch('/umbraco/api/resourcesApi/GetBranchContactDictionary')
            .then(response => response.json())
                .then((data) => {
                    vm.dictionary = data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    vm.loading = false;
                });

                
            vm.selectedBrand = vm.brands[0].FilterAlias;
    },
    watch: {
        selectedBrand: {
            handler(newVal, oldVal) {
                this.handleBrandChange(newVal);
            }
        }
    },
    methods: {
        handleBrandChange(brand) {
            const vm = this;
            vm.loading = true;

            vm.departments = null;
            vm.selectedDepartment = null;

            const object = {
                shopIds: vm.shops.join(','),
                brand:brand,
            }


            fetch('/umbraco/api/shopApi/GetShopDepartmentsByBrand?' + new URLSearchParams(object))
                .then(response => response.json())
                .then(data => {
                    vm.departments = data;

                    if(vm.departments && vm.departments.length == 1) {
                        vm.selectedDepartment = vm.departments[0];
                    }else {
                        vm.selectedDepartment = vm.departments.find(x=>x.typeId === 2) ?? null;
                    }

                    vm.loading = false;

                })
                .catch(error => {
                    console.log(error);
                    vm.loading = false;
                })
        }
    }
};
</script>
